import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Http, Response } from '@angular/http';
import { Market } from '@ionic-native/market';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { LoginPage } from '../login/login';
import { ProddetailsPage } from '../proddetails/proddetails'
import {
  Product, ProductMappingList, MyCartList, LoginInfo, PagingList, AutocompleteItem,
  ProductFilterModel, BannerProductTypeVM, ProductTypelist, LocationList, ProfileViewModel
} from '../model/types'
import { ProductService } from '../service/product_service'
import { AppSharedService } from '../service/app_shared';
import { UserService } from '../service/user_service';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {
  //class variable

  selectedValue:any;
  AutoComItems: AutocompleteItem[] = [];
  SelectedProd = ProductMappingList;
  SearchText: string;
  ShowList: boolean = false;
  ImageUrlSmall: string;
  ImageUrlResources: string;
  CategoryId: number[];
  SubCategoryId: number[];
  BrandId: number[];
  LocationId: number[];
  VendorId: number[];
  ProductTypeId: number[];
  PageNumber: number;
  KeyWord: string;
  ReActiveInfinite: any;
  TotalPages: number;
  TotalCount: number;
  BannerList: string[];
  ProdTypeList: ProductTypelist[];
  ImageUrlProdType: string;
  locationList: LocationList[];
  currentUserLocationId: number;
  unitMasters: any[] = [];
  productUnitMapping: any[] = [];
  //constructor
  constructor(public navCtrl: NavController
    , public navParams: NavParams
    , public prodService: ProductService
    , public storage: Storage
    , public appSharedService: AppSharedService
    , public loadingCtrl: LoadingController
    , private http: Http
    , private alertCtrl: AlertController
    , private market: Market
    , private httpc: HttpClient
    , public userService: UserService
  ) {
    this.CategoryId = [];
    this.SubCategoryId = [];
    this.BrandId = [];
    this.ProductTypeId = [];
    this.LocationId = [1];
    this.VendorId = [];
    // intialize class variable
    if (navParams.data.categoryId != undefined && navParams.data.categoryId != null && navParams.data.categoryId != 0) {
      this.CategoryId = [navParams.data.categoryId];
    }

    if (navParams.data.subCategoryId != undefined && navParams.data.subCategoryId != null && navParams.data.subCategoryId != 0) {
      this.SubCategoryId = [navParams.data.subCategoryId];
    }
    if (navParams.data.brandId != undefined && navParams.data.brandId != null && navParams.data.brandId != 0) {
      this.BrandId = [navParams.data.brandId];
    }
    if (navParams.data.productTypeId != undefined && navParams.data.productTypeId != null && navParams.data.productTypeId != 0) {
      this.ProductTypeId = [navParams.data.productTypeId];
    }
    if (navParams.data.vendorId != undefined && navParams.data.vendorId != null && navParams.data.vendorId != 0) {
      this.VendorId = [navParams.data.vendorId];
    }
    this.PageNumber = 1;
    this.KeyWord = navParams.data.keyword || "";
    this.SearchText = "";
    this.ImageUrlSmall = this.appSharedService.configInfo.applicationInfo.fileBasePath + '/' + this.appSharedService.configInfo.applicationInfo.pathSmallImageUrl;
    this.ImageUrlResources = this.appSharedService.configInfo.applicationInfo.fileBasePath + '/images/banner/app/';
    this.ImageUrlProdType = this.appSharedService.configInfo.applicationInfo.fileBasePath + '/images/product/prodtype/';
    this.initializeOnLoad();
    this.BannerList = ["test.jpg"];
    this.ProdTypeList = [];
  }

  ngOnInit() {
    //get user info
    this.storage.get("bz_user_02").then((userinfo: LoginInfo) => {
      if (userinfo != undefined && userinfo != null && userinfo.Token != undefined) {
        this.currentUserLocationId = userinfo.LocationId;
        this.GetProduct();
        this.GetBanner(userinfo.LocationId);
        this.getLocationList();
      }
    });
  }

  ionViewDidEnter() {
    this.initializeOnLoad();
  }
  // get bannerlist
  GetBanner(LocationId: number) {
    var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetBannerList);
    url = url + '/' + LocationId

    // get banner
    this.http.get(url)
      .map((data: Response) => {
        return data.json() as BannerProductTypeVM;
      }).toPromise().then(x => {
        // assign response variable                              
        this.prodService.BannerList = x.bannerImageList;
        this.ProdTypeList = x.productTypeList;
        if (this.appSharedService.configInfo.applicationInfo.currentAppVersion != x.applicationInfo.currentAppVersion) {
          console.log(x.applicationInfo.currentAppVersion);
          let message = "New version of bazaarhub is available in play store. Please update to get better experience.";
          this.alertCtrl.create({
            title: 'Info',
            subTitle: message,
            buttons: ['OK']
          }).present();
          console.log();
          this.market.open(this.appSharedService.configInfo.applicationInfo.googlePackageName);
        }
      });
  }


  GetProduct() {
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    //show loader
    loading.present();
    //get url
    var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductForAppv2);
    let prodfiltermodel: ProductFilterModel = {
      BrandId: this.BrandId,
      CategoryId: this.CategoryId,
      keyword: this.KeyWord,
      LocationId: this.LocationId,
      PageNumber: this.PageNumber,
      ProductTypeId: this.ProductTypeId,
      VendorId: this.VendorId,
      SubCategoryId: this.SubCategoryId,
      ProductId: []
    }
    // get product
    this.http.post(url, prodfiltermodel)
      .map((data: Response) => {
        return data.json() as PagingList;
      }).toPromise().then(x => {

        // assign response variable                              
        this.prodService.productList = x.ProductList;
        this.PageNumber = x.CurrentPage;
        this.TotalCount = x.TotalRecord;
        this.TotalPages = x.TotalPage;
        loading.dismiss();
        if(x.ProductList != null && x.ProductList.length > 0){       
          x.ProductList.forEach(element => {
            this.callUnitAmount(element);
          });  
        }
      });
  }

  //initialization
  GetUnitMaster() {
    //get url
    let url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductUnitForAppv2);
    this.httpc.get(url, { observe: 'response' }).subscribe((res: HttpResponse<any>) => {
      if (res.status == 200) {
        if (res.body != undefined && res.body != null) {
          this.unitMasters = res.body;
        }
      }
    });
  }

  disproc(e){
    console.log(e.target.value);
    this.selectedValue= e.target.value;
  }

  onBlurtxtQuantity(product: Product) {
    this.callUnitAmount(product);
  }

    callUnitAmount(product: Product){

      setTimeout(() => {
        const ddlMapping = "ddl_mapping_" + product.ProductId.toString() + "_" + product.VendorId.toString();
        let ddlMappingElement = <HTMLSelectElement>document.getElementById(ddlMapping);
        
        const id = "txtQuantity_" + product.ProductId.toString() + "_" + product.VendorId.toString();
        const inputQty = <HTMLInputElement>document.getElementById(id);
    

        const idTxt = "txt_type_" + product.ProductId.toString() + "_" + product.VendorId.toString();
        const inputTxtQty = <HTMLLabelElement>document.getElementById(idTxt);

        if (ddlMappingElement && ddlMappingElement.value && inputQty && inputQty.value) {

          let unitId = product.ProductMappingList.find(function (element) {
            return element.ProductMappingId.toString() === ddlMappingElement.value;
          });
          if(unitId != null){

            this.GetUnitAmount(product.ProductId, product.VendorId, unitId.ProductUnitId, inputQty.value);
            if(inputTxtQty != null){
              inputTxtQty.innerText = unitId.ProductUnitName;
            }
          }

        }
      }, 1000); 
    }

  getProductUnitMapping(productId: any, vendorId: number) {
    //get url
    let url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductUnitMappingForAppv2 + productId);

    // get product
    this.httpc.get(url, { observe: 'response' }).subscribe((res: HttpResponse<any>) => {
      if (res.status == 200) {
        if (res.body != undefined && res.body != null) {
          this.productUnitMapping = res.body;
          let pTag = <HTMLParagraphElement>document.getElementById("p_unit_map_" + productId + "_" + vendorId);
          let htmlValue = '';
          res.body.forEach(element => {
            htmlValue += element.Product_Min_Quantity + ' - ' + (element.Product_Max_Quantity ? element.Product_Max_Quantity : 'Above') + ' ' + element.UnitName + ' (' + element.ProductUnit_Description + ') MRP: ' + element.Price + '</br>';
          });
          pTag.innerHTML = htmlValue;
        }
      }
    });
  }

  GetUnitAmount(productId: any, vendorId: number, unitId: any, quantity: any) {
    //get url
    unitId = parseInt(unitId);
    quantity = parseInt(quantity);
    let url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductUnitAmountForAppv2 + productId + '/unitamount/' + unitId + '/' + quantity + '/' + vendorId);

    // get product
    this.httpc.get(url, { observe: 'response' }).subscribe((res: HttpResponse<any>) => {
      if (res.status == 200) {
        if (res.body != undefined && res.body != null) {
          const paragraphElementTotalAmount = <HTMLParagraphElement>document.getElementById("amount_" + productId + "_" + vendorId);
          paragraphElementTotalAmount.innerHTML ='DP: '+ res.body
        }
      }
    });
  }

  showProductPrice(productMapping: any) {
    return productMapping.filter(x => x.Product_Min_Quantity > 0).length > 0;
  }

  initializeOnLoad() {
    //get user info
    this.storage.get("bz_user_02").then((userinfo: LoginInfo) => {
      if (userinfo != undefined && userinfo != null && userinfo.Token != undefined) {
        this.LocationId = [userinfo.LocationId];
      }
    });

    //get cart info
    this.storage.get('bz_cart_02').then((data) => {
      this.prodService.MyCarItemList = data;
      this.prodService.TotalCartLength = (data != undefined && data != null ? data.length : 0);
      this.prodService.CartTotalAmount = this.prodService.utility_calculateCartAmount((data != undefined ? data : null));
    });
  }
  // go to details page
  gotoDetails(obj: Product) {
    this.prodService.selectedProduct = obj;
    this.navCtrl.push(ProddetailsPage);
  }

  //clear autocomplete
  clearAutocomplete() {
    this.ResetAllField();
    this.GetProduct();
  }

  ResetAllField() {
    this.SearchText = "";
    this.KeyWord = "";
    this.BrandId = [];
    this.CategoryId = [];
    this.SubCategoryId = [];
    this.ShowList = false;
    this.PageNumber = 1;
    this.ProductTypeId = [];
    this.VendorId = [];
    if (this.ReActiveInfinite != undefined && this.ReActiveInfinite != null) {
      this.ReActiveInfinite.enable(true);
    }
  }
  // on demand page load
  doInfinite(infiniteScroll) {
    this.ReActiveInfinite = infiniteScroll;
    //if pagenumber less then total page then only call
    if (this.PageNumber < this.TotalPages) {
      //get url
      var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductForAppv2);
      let prodfiltermodel: ProductFilterModel = {
        BrandId: this.BrandId,
        CategoryId: this.CategoryId,
        keyword: this.KeyWord,
        LocationId: this.LocationId,
        PageNumber: this.PageNumber + 1,
        ProductTypeId: this.ProductTypeId,
        SubCategoryId: this.SubCategoryId,
        VendorId: this.VendorId,
        ProductId: []
      }
      this.http.post(url, prodfiltermodel)
        .map((data: Response) => {
          return data.json() as PagingList;
        }).toPromise().then(x => {
          if (x != undefined && x != null && x.ProductList != undefined && x.ProductList != null) {
            //set reponse variable
            x.ProductList.forEach(childObj => {
              this.prodService.productList.push(childObj);
            });
            this.PageNumber = x.CurrentPage;
            this.TotalCount = x.TotalRecord;
            this.TotalPages = x.TotalPage;
          }
          infiniteScroll.complete();
          if(x.ProductList != null && x.ProductList.length > 0){       
            x.ProductList.forEach(element => {
              this.callUnitAmount(element);
            });  
          }
        });
        
    }
    else {
      infiniteScroll.enable(false);
    }
  }

  //set auto complete
  setAutoCompleteItem(prodObj: AutocompleteItem) {
    this.CategoryId = [];
    this.SubCategoryId = [];
    this.VendorId = [];
    this.BrandId = [];
    this.SearchText = prodObj.SearchText;
    if (prodObj.Brand != null && prodObj.Brand != 0) {
      this.BrandId.push(prodObj.Brand);
    }
    if (prodObj.Category != null && prodObj.Category != 0) {
      this.CategoryId.push(prodObj.Category);
    }
    if (prodObj.SubCategory != null && prodObj.SubCategory != 0) {
      this.SubCategoryId.push(prodObj.SubCategory);
    }
    this.ShowList = false;
    this.PageNumber = 1;
    this.KeyWord = prodObj.SearchText;
    this.VendorId = [];

    if (this.ReActiveInfinite != undefined && this.ReActiveInfinite != null) {
      this.ReActiveInfinite.enable(true);
    }
    this.GetProduct();
  }

  //add to cart
  addToCart(product: Product) {
    this.AddFalseLoadingBar();
    //get ddl
    let id = "ddl_mapping_" + product.ProductId.toString() + "_" + product.VendorId.toString();
    let ddl = <HTMLSelectElement>document.getElementById(id);

    let unitId = product.ProductMappingList.find(function (element) {
      return element.ProductMappingId.toString() === ddl.value;
    });


    let mapItem;

    const txtQuantity = "txtQuantity_" + product.ProductId.toString() + "_" + product.VendorId.toString();
    let inputQty = <HTMLInputElement>document.getElementById(txtQuantity);
    let quantity = parseInt(inputQty.value);

    let isMinQuantity = product.ProductMappingList.filter(function (el) {
      return (el.Product_Min_Quantity > 0)
    }).length > 0


    if (isMinQuantity) {
      mapItem = product.ProductMappingList.filter(function (el) {
        return (quantity > el.Product_Min_Quantity && el.Product_Max_Quantity == undefined)
      })[0];

      if (mapItem == undefined || mapItem == null) {
        mapItem = product.ProductMappingList.filter(function (el) {
          return (el.Product_Min_Quantity <= quantity && el.Product_Max_Quantity >= quantity)
        })[0];
      }
    }
    else {
      mapItem = product.ProductMappingList.filter(function (el) {
                return el.ProductMappingId == parseInt(ddl.selectedOptions[0].value)
              })[0];
    }
    if (unitId != undefined && unitId != null && quantity > 0) {
      // add to my cart
      let myCart: MyCartList = {
        ProductMappingId: mapItem.ProductMappingId,
        ProductName: product.ProductName + (product.BrandName != null ? "(" + product.BrandName + ")" : ""),
        ProductPrice: mapItem.CustomerPrice,
        ProductUnitId: mapItem.Product_Min_Quantity > 0 ? unitId.ProductUnitId : 0,
        ProductMinQuantity: mapItem.Product_Min_Quantity,
        ProductQuantity: mapItem.Product_Min_Quantity > 0 ? parseInt(inputQty.value) : 1,
        ProductQuantityDescription: mapItem.ProductQuantityDescription,
        ProductTotalAmount: mapItem.CustomerPrice,
        ProductId: product.ProductId,
        Picture1: product.Picture,
        VendorId: product.VendorId,
        VendorName: product.VendorName
      }
       this.AddProductToCart(myCart);
    }
  }

  //add scroll bar

  AddFalseLoadingBar() {
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    //show loader
    loading.present();
    setTimeout(function () {
      loading.dismiss();
    }, 1000);
  }
  // add product to cart
  AddProductToCart(cartObj: MyCartList) {
    this.storage.get("bz_cart_02").then((data) => {
      if (data != null && data != undefined && data.length > 0) {
        let alreadyAdded = false;
        let alreadyAddedIndex = -1;
        for (let i = 0; i < data.length; i++) {
          if (data[i].ProductMappingId == cartObj.ProductMappingId) {
            alreadyAdded = true;
            alreadyAddedIndex = i;
            break;
          }
        }

        if (alreadyAdded == true) {
          data[alreadyAddedIndex].ProductQuantity = data[alreadyAddedIndex].ProductQuantity + 1;
          data[alreadyAddedIndex].ProductTotalAmount = data[alreadyAddedIndex].ProductQuantity * data[alreadyAddedIndex].ProductPrice;
          this.storage.set('bz_cart_02', data).then(() => {
            this.prodService.MyCarItemList = data;
            this.prodService.TotalCartLength = (data != undefined && data != null ? data.length : 0);
            this.prodService.utility_GetProductListFromCart();
          });
        }
        else {
          data.push(cartObj);
          this.storage.set('bz_cart_02', data).then(() => {
            this.prodService.MyCarItemList = data;
            this.prodService.TotalCartLength = (data != undefined && data != null ? data.length : 0);
            this.prodService.utility_GetProductListFromCart();
          });
        }
      }
      else {
        var mylist: MyCartList[] = [];
        mylist.push(cartObj);
        this.storage.set('bz_cart_02', mylist).then(() => {
          this.prodService.MyCarItemList = data;
          this.prodService.TotalCartLength = 1;
          this.prodService.utility_GetProductListFromCart();
        });
      }
    }
    );
  }

  searchProductExplicitly() {
    this.CategoryId = [];
    this.SubCategoryId = [];
    this.BrandId = [];
    this.KeyWord = this.SearchText;
    this.ShowList = false;
    this.PageNumber = 1;
    this.VendorId = [];
    if (this.ReActiveInfinite != undefined && this.ReActiveInfinite != null) {
      this.ReActiveInfinite.enable(true);
    }
    this.GetProduct();
  }

  // get auto complete items
  getAutoCompleteItems(ev: any) {
    // set val to the value of the searchbar
    let val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '' && (val.length % 2 == 0)) {
      // get autocomplete
      var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlAutocomplete);
      if (this.LocationId.length > 0) {
        url = url + '/' + this.LocationId[0] + '/' + val;
      }

      //get autocomplete
      this.http.get(url)
        .map((data: Response) => {
          return data.json() as AutocompleteItem[];
        }).toPromise().then(x => {
          if (x != undefined && x != null && x.length > 0) {
            this.AutoComItems = x;
            this.ShowList = true;
          }
          else {
            this.AutoComItems = [];
            this.ShowList = false;
          }
        });
    }
  }

  FilterByProductType(ProductTypeId: number) {
    this.ResetAllField();
    this.ProductTypeId.push(ProductTypeId);
    this.GetProduct();
  }

  getLocationList() {
    // set the url
    var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + "/" + this.appSharedService.configInfo.urlInfo.urlGetLocationList)
    this.storage.get("bz_user_02").then((userinfo: LoginInfo) => {
      if (userinfo != undefined && userinfo != null && userinfo.Token != undefined) {
        // do the service call
        this.httpc.get(url, { observe: 'response' })
          .subscribe((res: HttpResponse<any>) => {
            if (res.status == 200) {
              if (res.body != undefined && res.body != null) {
                this.currentUserLocationId = userinfo.LocationId;
                this.locationList = res.body as LocationList[];
              }
            }
          });
      }
    });
  }

  UpdateLocation() {
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    this.storage.get("bz_user_02").then((userinfo: LoginInfo) => {
      // set view model
      if (userinfo != undefined && userinfo != null && userinfo.Token != undefined) {
        var reg: ProfileViewModel = {
          Email: '',
          CustomerName: '',
          Password: '',
          PhoneNumber: '',
          PostalCode: '',
          LocationId: this.currentUserLocationId
        }

        //create header
        let myheaders = new HttpHeaders();
        myheaders = myheaders.append('Content-Type', 'application/json');
        myheaders = myheaders.append('token', userinfo.Token);

        //create url
        var url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlUpdateLocation);
        //show the loader
        loading.present();

        // do the service call
        this.httpc.post(url, reg, { headers: myheaders, observe: 'response' })
          .subscribe((res: HttpResponse<any>) => {
            if (res.status == 200) {
              loading.dismiss();
              this.storage.remove("bz_user_02");
              if (userinfo.LocationId != this.currentUserLocationId) {
                this.storage.remove("bz_cart_02");
              }
              this.LocationId = [this.currentUserLocationId];
              userinfo.LocationId = this.currentUserLocationId;
              userinfo.LocationName = this.locationList
                .find(item => item.locationId == this.currentUserLocationId)
                .locationName;
              this.storage.set("bz_user_02", userinfo);
              this.GetProduct();
              this.GetBanner(this.currentUserLocationId);
            }
            else if (res.status == 204) {
              loading.dismiss();
              this.storage.clear();
              this.navCtrl.popToRoot();
              this.navCtrl.setRoot(LoginPage);
            }
            else {
              let message = this.appSharedService.getHttpResponseMessage(res, 'There is problem with profile update. please try after sometime!');
              loading.dismiss();
              // show error message
              this.alertCtrl.create({
                title: 'Error!',
                subTitle: message,
                buttons: ['OK']
              }).present();
            }
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts